import styled from 'styled-components'
import { ReactComponent as CrossCircleSvg } from '@sketch/icons/cross-circle-18-svg'
import { Link as RouterLink } from 'react-router-dom'

export const Link = styled(RouterLink)`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};

  &:hover {
    color: ${({ theme }) => theme.colors.foreground.secondary.D};
  }

  &:active {
    color: ${({ theme }) => theme.colors.foreground.secondary.D};
  }
`

export const Icon = styled(CrossCircleSvg)`
  width: 18px;
`
